export default "__VITE_ASSET__BELx$pxt__"